import Grid from "@material-ui/core/Grid";
import React, { useEffect } from "react";
import OnceSubscriptions from "../components/Subscriptions/OnceSubscriptions/OnceSubscriptions";
import { ToastContainer } from "react-toastify";
import AddSubscriptionDialog from "../components/AddSubscriptionDialog/AddSubscriptionDialog";
import CircularProgress from "@material-ui/core/CircularProgress";
import cloudStore from "../store/CloudStore";
import { _get } from "../Api";
import RemoveSubscriptionDialog from "../components/RemoveSubscriptionDialog/RemoveSubscriptionDialog";
import { useParams } from "react-router-dom";
import _ from "lodash";
import TAQRSubscriptions from "../components/Subscriptions/TAQRSubscriptions/TAQRSubscriptions";
import SPQRSubscriptions from "../components/Subscriptions/SPQRSubscriptions/SPQRSubscriptions";
import TCountSubscriptions from "../components/Subscriptions/TCountSubscriptions/TCountSubscriptions";
import PaymentDialog from "../components/PaymentDialog/PaymentDialog";
import TAmountSubscriptions from "../components/Subscriptions/TAmountSubscriptions/TAmountSubscriptions";
import PillarSubscriptions from "../components/Subscriptions/PillarSubscriptions/PillarSubscriptions";

export default function Subscriptions() {
  const [merchant, setMerchant] = React.useState(null);
  const [wefactMerchants, setWefactMerchants] = React.useState(null);
  const [addDialogType, setAddDialogType] = React.useState(null);
  const [removeDialogType, setRemoveDialogType] = React.useState(null);
  const [subscriptions, setSubscriptions] = React.useState(null);
  const [selectedSubscription, setSelectedSubscription] = React.useState(null);
  const [paymentMode, setPaymentMode] = React.useState(null);
  const [paymentSub, setPaymentSub] = React.useState(null);
  const merchantId = parseInt(useParams().merchantId);

  const onChange = () => {
    setMerchant(cloudStore.merchant);
  };

  useEffect(() => {
    cloudStore.addChangeListener(onChange);
    if (cloudStore.merchant != null) {
      onChange();
    }
    return () => cloudStore.removeChangeListener(onChange);
  }, []);

  useEffect(() => {
    if (wefactMerchants == null) {
      fetchWefactMerchants(setWefactMerchants);
    }
  }, [wefactMerchants]);

  useEffect(() => {
    if (subscriptions == null) {
      fetchSubscriptions(setSubscriptions);
    }
  }, [subscriptions]);

  const fetchWefactMerchants = (setWefactMerchants) => {
    _get("/nova/wefactmerchant")
      .then((response) => {
        setWefactMerchants(_.cloneDeep(response.data));
      })
      .catch((error) => console.log(error));
  };

  const fetchSubscriptions = (setSubscriptions) => {
    _get("/nova/merchant/" + merchantId + "/subscription")
      .then((response) => {
        setSubscriptions(_.cloneDeep(response.data));
      })
      .catch((reason) => {
        console.log(reason);
        return Promise.reject(reason);
      });
  };

  if (!cloudStore.merchant || !wefactMerchants || !subscriptions) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <Grid>
      <Grid container direction="column" spacing={2}>
        <Grid item>
          <OnceSubscriptions
            key={subscriptions}
            wefactMerchants={wefactMerchants}
            merchantType={"ONCE"}
            subscriptions={subscriptions}
            editable={true}
            setAddDialogType={setAddDialogType}
            setRemoveDialogType={setRemoveDialogType}
            setSelectedSubscription={setSelectedSubscription}
          />
        </Grid>
        <Grid item>
          <TAQRSubscriptions
            key={subscriptions}
            wefactMerchants={wefactMerchants}
            merchant={merchant}
            subscriptions={subscriptions}
            editable={true}
            setAddDialogType={setAddDialogType}
            setRemoveDialogType={setRemoveDialogType}
            setSelectedSubscription={setSelectedSubscription}
          />
        </Grid>
        <Grid item>
          <SPQRSubscriptions
            key={subscriptions}
            wefactMerchants={wefactMerchants}
            merchant={merchant}
            subscriptions={subscriptions}
            editable={true}
            setAddDialogType={setAddDialogType}
            setRemoveDialogType={setRemoveDialogType}
            setSelectedSubscription={setSelectedSubscription}
          />
        </Grid>
        <Grid item>
          <TCountSubscriptions
            key={subscriptions}
            merchantType={"TA_TRANSACTION_COUNT"}
            wefactMerchants={wefactMerchants}
            merchant={merchant}
            subscriptions={subscriptions}
            editable={true}
            setAddDialogType={setAddDialogType}
            setRemoveDialogType={setRemoveDialogType}
            setSelectedSubscription={setSelectedSubscription}
          />
        </Grid>
        <Grid item>
          <TCountSubscriptions
            key={subscriptions}
            merchantType={"SP_TRANSACTION_COUNT"}
            wefactMerchants={wefactMerchants}
            merchant={merchant}
            subscriptions={subscriptions}
            editable={true}
            setAddDialogType={setAddDialogType}
            setRemoveDialogType={setRemoveDialogType}
            setSelectedSubscription={setSelectedSubscription}
          />
        </Grid>
        <Grid item>
          <TCountSubscriptions
            key={subscriptions}
            merchantType={"PAYNL_TRANSACTION_COUNT"}
            wefactMerchants={wefactMerchants}
            merchant={merchant}
            paymentMode={paymentMode}
            setPaymentMode={setPaymentMode}
            setPaymentSub={setPaymentSub}
            paymentSub={paymentSub}
            subscriptions={subscriptions}
            editable={true}
            setAddDialogType={setAddDialogType}
            setRemoveDialogType={setRemoveDialogType}
            selectedSubscription={selectedSubscription}
            setSelectedSubscription={setSelectedSubscription}
          />
        </Grid>
        <Grid item>
          <TAmountSubscriptions
            key={subscriptions}
            merchantType={"TA_TRANSACTION_AMOUNT"}
            wefactMerchants={wefactMerchants}
            merchant={merchant}
            paymentMode={paymentMode}
            setPaymentMode={setPaymentMode}
            setPaymentSub={setPaymentSub}
            paymentSub={paymentSub}
            subscriptions={subscriptions}
            editable={true}
            setAddDialogType={setAddDialogType}
            setRemoveDialogType={setRemoveDialogType}
            selectedSubscription={selectedSubscription}
            setSelectedSubscription={setSelectedSubscription}
          />
        </Grid>
        <Grid item>
          <TAmountSubscriptions
            key={subscriptions}
            merchantType={"SP_TRANSACTION_AMOUNT"}
            wefactMerchants={wefactMerchants}
            merchant={merchant}
            paymentMode={paymentMode}
            setPaymentMode={setPaymentMode}
            setPaymentSub={setPaymentSub}
            paymentSub={paymentSub}
            subscriptions={subscriptions}
            editable={true}
            setAddDialogType={setAddDialogType}
            setRemoveDialogType={setRemoveDialogType}
            selectedSubscription={selectedSubscription}
            setSelectedSubscription={setSelectedSubscription}
          />
        </Grid>
        <Grid item>
          <PillarSubscriptions
            key={subscriptions}
            merchantType={"PILLAR_USER"}
            wefactMerchants={wefactMerchants}
            merchant={merchant}
            paymentMode={paymentMode}
            setPaymentMode={setPaymentMode}
            setPaymentSub={setPaymentSub}
            paymentSub={paymentSub}
            subscriptions={subscriptions}
            editable={true}
            setAddDialogType={setAddDialogType}
            setRemoveDialogType={setRemoveDialogType}
            selectedSubscription={selectedSubscription}
            setSelectedSubscription={setSelectedSubscription}
          />
        </Grid>
        <AddSubscriptionDialog
          wefactMerchants={wefactMerchants}
          merchant={merchant}
          dialogType={addDialogType}
          setDialogType={setAddDialogType}
          setPaymentMode={setPaymentMode}
          subscriptions={subscriptions}
          setPaymentSub={setPaymentSub}
          paymentSub={paymentSub}
          setSubscriptions={setSubscriptions}
        />
        <RemoveSubscriptionDialog
          merchant={merchant}
          dialogType={removeDialogType}
          setDialogType={setRemoveDialogType}
          setSelectedSubscription={setSelectedSubscription}
          selectedSubscription={selectedSubscription}
          setSubscriptions={setSubscriptions}
          subscriptions={subscriptions}
        />
        <PaymentDialog
          key={selectedSubscription}
          setSubscriptions={setSubscriptions}
          subscriptions={subscriptions}
          setDialogType={setAddDialogType}
          paymentSub={paymentSub}
          setPaymentSub={setPaymentSub}
          selectedSubscription={selectedSubscription}
          paymentMode={paymentMode}
          setPaymentMode={setPaymentMode}
        />
        <ToastContainer
          position="bottom-right"
          autoClose={2000}
          hideProgressBar
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Grid>
    </Grid>
  );
}
